import React, {useLayoutEffect, useRef} from "react";
import Pusher, {Options} from "pusher-js";
import {ModifyURL} from "@/base/utils/fetch";
import {useUser} from "@/base/components/auth/UserProvider";
import {DelayedEffectHook} from "@/base/types/delayed-effect.hook";

type Props = {
	dependencies: string[],
	setPusher: (pusher: Pusher) => void,
	pusher: Pusher | null,
	options: any,
}

type AuthHandler = (data: any, callback: (err: any, data: any) => void) => void

export default function PusherInstance({
	dependencies = [],
	setPusher,
	pusher = null,
	options,
}: Props) {
	const UserContext = useUser();

	const UserContextRef = useRef(UserContext);

	useLayoutEffect(() => {
		UserContextRef.current = UserContext;
	}, [UserContext, UserContext.user, UserContext.Fetch]);

	const authHandler: AuthHandler = async (data, callback) => {
		console.log('[WS] Pusher try auth for ' + data.channelName + ", as " + UserContextRef.current.user?.id + ", is logged in: " + UserContextRef.current.loggedIn);
		return UserContextRef.current.Fetch({
			url: ModifyURL(`/pusher/auth`),
			method: 'POST',
			body: {
				socketId: data.socketId,
				channelName: data.channelName,
			}
		}).then(res => {
			if (res && res.data && res.data.auth)
			{
				console.log('[WS] Pusher auth success for ' + data.channelName);

				callback(null, {
					auth: res.data.auth,
					channel_data: res.data.channel_data || null
				});
			}
			else
			{
				throw new Error('Invalid response data: ' + JSON.stringify(res));
			}
		}).catch(err => {
			console.error(err)
			console.error('[WS] Pusher auth error for ' + data.channelName + ' ' + err.message + ' ' + UserContextRef.current.user?.id);

			callback(err, null);
		});
	};

	DelayedEffectHook(() => {
		let IsClient = typeof window !== 'undefined';

		if (IsClient)
		{
			if (pusher != null)
			{
				return;
			}

			const pusherOptions: Options = {
				// broadcaster: 'pusher',
				cluster: process.env.NEXT_PUBLIC_PUSHER_APP_CLUSTER as string,
				forceTLS: process.env.NEXT_PUBLIC_PUSHER_APP_SCHEME == 'https',
				wsHost: process.env.NEXT_PUBLIC_PUSHER_APP_HOST_SELF ? window.location.hostname : process.env.NEXT_PUBLIC_PUSHER_APP_HOST,
				wsPort: parseInt(process.env.NEXT_PUBLIC_PUSHER_APP_PORT || "443"),
				wssPort: parseInt(process.env.NEXT_PUBLIC_PUSHER_APP_PORT || "443"),
				channelAuthorization: {
					customHandler: authHandler,
				},
				...options,
			};

			if (typeof window != "undefined" && window.WebSocket)
			{
				const oldWebSocket = window.WebSocket;
				// @ts-ignore
				window.WebSocket = function (url: string, protocols: string | string[]) {
					console.debug('[WS] WebSocket created', url, protocols);
					try
					{
						const ws = new oldWebSocket(url, protocols);
						ws.addEventListener('error' as any, (e) => {
							console.warn('[WS] WebSocket error', e);
						});
						ws.addEventListener('close' as any, (e) => {
							console.warn('[WS] WebSocket close', e);
						});
						return ws;
					}
					catch (e)
					{
						console.error(e);
						throw e;
					}
				}
			}

			let pInstance = new Pusher(process.env.NEXT_PUBLIC_PUSHER_APP_KEY as string, pusherOptions);

			setPusher(pInstance);
		}
	}, dependencies, 200);

	return (
		<></>
	);
}